import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-coming-soon',
	templateUrl: './coming-soon.component.html',
	styleUrl: './coming-soon.component.scss'
})
export class ComingSoonComponent {
	@Input() title: string = '';
}
